import React, { Component } from "react";

export class TxFee extends Component {
  static displayName = TxFee.name;

  constructor(props) {
    super(props);
    this.state = { fees: {}, initialized: false };
  }

  componentDidMount() {
    this.getFeeData();
  }

  async getFeeData() {
    const resp = await fetch("/stats/btcfee");
    const data = await resp.json();
    this.setState({ fees: data, initialized: true });
  }

  static renderTable(fees) {
    return (
      <table className="table table-striped" aria-labelledby="tabelLabel">
        <tbody>
          <tr>
            <th>Avg fee in US$ (24h): </th>
            <td>$ {fees.average_transaction_fee_usd_24h}</td>
          </tr>
          <tr style={{ color: "green", fontWeight: "bold" }}>
            <th>Median fee in US$ (24h): </th>
            <td>$ {fees.median_transaction_fee_usd_24h}</td>
          </tr>
          <tr>
            <th>Avg fee in sats (24h): </th>
            <td>{fees.average_transaction_fee_24h} sats</td>
          </tr>
          <tr>
            <th>Median fee in sats (24h): </th>
            <td>{fees.median_transaction_fee_24h} sats</td>
          </tr>
        </tbody>
      </table>
    );
  }

  render() {
    let contents = this.state.initialized ? (
      TxFee.renderTable(this.state.fees)
    ) : (
      <p style={{ fontStyle: "italic" }}>
        <em>Loading...</em>
      </p>
    );

    return (
      <div className="mbox">
        <h4 className="text-center" title="The Bitcoin network fee is the amount of satoshis (sats) paid to miners for including a transaction in a block. The fee can vary based on network congestion and transaction size.">
          <i className="bi bi-thermometer-half" style={{ color: "darkgreen" }}></i>
          <span className="m-2"> Bitcoin Network Fee</span>
        </h4>
        <hr />
        {contents}
        <br />
        <br />
        <div style={{ fontSize: 11 }} className="mt-4">
          <span className="p-2">source: blockchair</span>
        </div>
      </div>
    );
  }
}
